import React from 'react';
import cn from 'clsx';

import SizeBadge from '../../library/size-badge/size-badge';
import Typography from '../../library/typography/typography';

import { toInches } from '../../shared/utils/text/text';

import styles from './fitment-size.scss';

const formatTireSize = size => size && size.replace('-', ' ');

interface FitmentSizeProps {
  className?: string;
  isOE?: boolean;
  rideHeightType?: string;
  sizeQualifier?: string;
  tireLocation?: string;
  tireSize?: string;
  wheelDiameter?: string;
}

function FitmentSize(props: FitmentSizeProps) {
  const {
    isOE,
    rideHeightType,
    sizeQualifier,
    tireLocation,
    tireSize,
    wheelDiameter
  } = props;

  let tireLabelPrefix: string;

  if (rideHeightType && !isOE) {
    tireLabelPrefix = rideHeightType.toLowerCase();
  } else if (isOE) {
    tireLabelPrefix = 'factory';
  } else {
    tireLabelPrefix = 'optional';
  }

  return (
    <>
      {(isOE || sizeQualifier) && (
        <SizeBadge isOE={isOE} sizeQualifier={sizeQualifier} />
      )}
      <div className={cn(styles['details'], 'fitment-size__details')}>
        {Boolean(tireSize) && (
          <div className={cn(styles['tire'], 'fitment-size__tire')}>
            <Typography
              className={cn(styles['size'], 'fitment-size__size')}
              tag="span"
              weight="bold"
            >
              {formatTireSize(tireSize)}
            </Typography>

            {(rideHeightType || isOE || sizeQualifier) && (
              <Typography
                className={cn(styles['type-label'], 'fitment-size__type-label')}
                size="small"
                tag="span"
              >
                {tireLabelPrefix}{' '}
                {tireLocation ? `${tireLocation} tire` : 'tire size'}
              </Typography>
            )}
          </div>
        )}

        {Boolean(wheelDiameter) && (
          <div className={cn(styles['wheel'], 'fitment-size__wheel')}>
            <Typography
              className={cn(styles['size'], 'fitment-size__wheel-size')}
              tag="span"
              weight="bold"
            >
              {toInches(wheelDiameter)}
            </Typography>
            <Typography
              className={cn(
                styles['type-label'],
                'fitment-size__wheel-type-label'
              )}
              size="small"
              tag="span"
            >
              wheels
            </Typography>
          </div>
        )}
      </div>
    </>
  );
}

export default FitmentSize;
